import { IRestaurantShift, ListItem, Pill, TIME_FORMAT, TLanguageKey } from '@localina/core';
import { RestaurantMenuIcon } from '@localina/icons';
import { DateTime, Info } from 'luxon';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
    shift: IRestaurantShift;
    onClick: (shift: IRestaurantShift) => void;
}

const WEEKDAYS = [1, 2, 3, 4, 5, 6, 7];

export const ShiftListItem: React.FC<IProps> = (props) => {
    const { t, i18n } = useTranslation();
    if (props.shift.shiftType !== 'recurrent') {
        return null;
    }

    const { name, from, to, expectedOccupancyTime, enabled, occurrence } = props.shift;
    const title = name[i18n.language as TLanguageKey];

    const time = (value: string) => DateTime.fromFormat(value, TIME_FORMAT).toFormat(TIME_FORMAT);

    const minutes = Math.round((expectedOccupancyTime || 0) / 60);
    const subtitle = [`${time(from)} – ${time(to)}`, minutes > 0 && t('availability.duration', { count: minutes })]
        .filter(Boolean)
        .join(' · ');

    const shortDays = Info.weekdays('short', { locale: i18n.language });

    const handleClick = () => {
        props.onClick(props.shift);
    };

    return (
        <ListItem
            classNames="shift-listitem recurrent-listitem"
            leftIcon={
                <span className="shift-listitem__icon">
                    <RestaurantMenuIcon />
                </span>
            }
            title={
                <div className="shift-listitem__row">
                    <div className="shift-listitem__main">
                        <span className="shift-listitem__name">{title}</span>
                        <span className="shift-listitem__when">{subtitle}</span>
                    </div>
                    {}
                    <div className="shift-listitem__days">
                        {WEEKDAYS.map((day) => (
                            <Pill
                                key={day}
                                tone={occurrence.includes(day) ? 'teal' : 'neutral'}
                                label={shortDays[day - 1]}
                                extraClassName={occurrence.includes(day) ? undefined : 'is-off'}
                            />
                        ))}
                    </div>
                    <Pill
                        tone={enabled ? 'good' : 'neutral'}
                        label={enabled ? t('availability.active') : t('availability.inactive')}
                    />
                </div>
            }
            onClick={handleClick}
        />
    );
};
